import React, { FunctionComponent } from 'react';
import { Dialog } from '@liveramp/motif/core/Dialog';
import Button from '@liveramp/motif/core/Button';
import TextField from '@liveramp/motif/core/TextField';
import ButtonGroup from '@liveramp/motif/core/ButtonGroup';
import Loader from '@liveramp/motif/core/Loader';
import styles from './styles.module.scss';
import useArchiveWorkOrderModalLogic from './useArchiveWorkOrderModalLogic';

const ArchiveWorkOrderModal: FunctionComponent = () => {
  const {
    activeArchiveButton,
    reasonOfArchiving,
    onArchiveSubmit,
    onReasonInputChange,
    isArchiveWorkOrdersModalOpened,
    onClose,
    isLoading
  } = useArchiveWorkOrderModalLogic();

  return (
    <Dialog
      open={isArchiveWorkOrdersModalOpened}
      onClose={onClose}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      aria-labelledby="simple-dialog"
    >
      <div className={styles.container}>
        <h3 className={styles.modalTitle}>Why are you archiving this work order?</h3>
        <TextField
          data-test-id="archiving-reason-input"
          className={styles.archivingReasonInput}
          label="Archiving reason"
          multiline
          fullWidth
          rows="4"
          value={reasonOfArchiving}
          onChange={onReasonInputChange}
        />
        <ButtonGroup className={styles.modalButtons}>
          <Button
            variant="text"
            color="primary"
            onClick={onClose}
            disabled={isLoading}
            data-test-id="cancel-archive-button"
          >
            Cancel
          </Button>
          {
            isLoading
              ? <Loader size="small" />
              : (
                <Button
                  color="primary"
                  type="submit"
                  data-test-id="submit-archive-button"
                  disabled={!activeArchiveButton}
                  onClick={onArchiveSubmit}
                >
                  Archive
                </Button>
              )
          }
        </ButtonGroup>
      </div>
    </Dialog>
  );
};

export default ArchiveWorkOrderModal;
